export default "__VITE_ASSET__CMAhJ9Uu__"